import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  id: string;
}

interface Result {}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/card/archive',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useArchiveCardLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useArchiveCardLazy;
